export default __webpack_public_path__ + "static/media/Group 4071.bf242b89.svg";